var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import './index.less';
import { PureComponent } from 'react';
import { string, func, bool, any, object } from 'prop-types';
import * as CLS from './cls';
import { eventStopper } from '../../util/event';

var LINK = 'link';
var QUERY = 'query';

var Link = function (_PureComponent) {
    _inherits(Link, _PureComponent);

    function Link() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Link);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Link.__proto__ || Object.getPrototypeOf(Link)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Link, [{
        key: 'render',
        value: function render() {
            var props = this.props;
            var type = props.type;

            var hoverable = Boolean(props.onClick);
            var className = CLS.LINK({ hoverable: hoverable, type: type }).mix(props.className)();

            return React.createElement(
                'a',
                {
                    className: className,
                    href: '#',
                    onContextMenu: this.handleContextMenu,
                    onClick: this.handleClick,
                    style: props.style,
                    ref: props.forwardedRef
                },
                props.children || props.text
            );
        }
    }]);

    return Link;
}(PureComponent);

Link.defaultProps = {
    query: false,
    type: '',
    url: '',
    className: '',
    style: null,
    text: ''
};
Link.propTypes = {
    query: bool,
    type: string,
    className: string,
    onClick: func,
    onContextMenu: func,
    url: string,
    text: string,
    payload: any,
    style: object
};

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.handleContextMenu = eventStopper(function (_ref2) {
        var x = _ref2.screenX,
            y = _ref2.screenY;
        var _props = _this2.props,
            onContextMenu = _props.onContextMenu,
            text = _props.text,
            url = _props.url,
            query = _props.query;


        if (onContextMenu) {
            onContextMenu({
                text: text,
                type: query ? QUERY : LINK,
                url: url,
                location: { x: x, y: y }
            });
        }
    });

    this.handleClick = function (event) {
        var _props2 = _this2.props,
            onClick = _props2.onClick,
            payload = _props2.payload,
            text = _props2.text,
            url = _props2.url;


        if (onClick) {
            var _args = payload ? payload : { text: text, url: url };

            onClick(_args, event);
        }
    };
};

export default Link;


export var LinkButton = function LinkButton(props) {
    return React.createElement(Link, _extends({}, props, { type: 'button' }));
};
export var LinkCommand = function LinkCommand(props) {
    return React.createElement(Link, _extends({}, props, { type: 'command' }));
};
export var LinkSearch = function LinkSearch(props) {
    return React.createElement(Link, _extends({}, props, { type: 'search' }));
};
export var LinkDomain = function LinkDomain(props) {
    return React.createElement(Link, _extends({}, props, { type: 'domain' }));
};
export var LinkText = function LinkText(props) {
    return React.createElement(Link, _extends({}, props, { type: 'text' }));
};
export var LinkAlt = function LinkAlt(props) {
    return React.createElement(Link, _extends({}, props, { type: 'alt' }));
};
export var LinkWhite = function LinkWhite(props) {
    return React.createElement(Link, _extends({}, props, { type: 'alt' }));
};
export var LinkSerp = function LinkSerp(props) {
    return React.createElement(Link, _extends({}, props, { type: 'serp' }));
};